import { gql } from '@apollo/client';

export const UPSERT_COMMUNITY_ACTION = gql`
  mutation UpsertCommunityAction($communityId: ID!, $actionName: String!, $input: UpsertActionInput!) {
    upsertCommunityAction(communityId: $communityId, actionName: $actionName, input: $input) {
      name
      type
      description
      deliveryType
      labels {
        labelId
        severity
      }
      policies
      operatorName
      deliverySettings {
        url
        postPayload
      }
    }
  }
`;
